import type { ComponentProps, FC } from "react";
import { TimelineEntry } from "web_myplann/NotificationCenter/Components/TimelineEntry";
import { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";

export const RecentPreviewEntry: FC<
	Omit<ComponentProps<typeof TimelineEntry>, "dateStyle">
> = (props) => (
	<TimelineEntry {...props} dateStyle={TimelineDateStyle.Relative} />
);
